import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { UserService } from 'src/app/services/user.service';
import { API } from 'src/environments/environment';

interface Opcao {
  id: number;
  descricao: string;
  dataEmissao?: string | null;
}

interface ItemComposicaoContaReceber {
  id: number;
  quantidade: number;
  descricao: string;
  valor: number;
  dataCadastro?: string | null;
  idOrcamento?: number | null;
  idOrcamentoItens?: number | null;
  idFinTabelaPreco?: number | null;
  planoContasId?: number | null;
  planoContasDescricao?: string | null;
}

interface ItemComposicaoEdicao {
  id: number;
  descricao: string;
  quantidade: number;
  valor: number;
  planoContasId: number;
}

@Component({
  selector: 'app-contas-receber',
  templateUrl: './contas-receber.component.html',
  styleUrls: ['./contas-receber.component.scss']
})
export class ContasReceberComponent implements OnInit {
  id = 0;
  ehPagamento = false;
  private carregandoRegistro = false;
  modalNovoClienteAberto = false;

  idFinDocumento = 0;
  idFinPagamento: number | null = null;
  idUsuarioPagador: number | null = null;
  idCentroCusto = 0;
  idPlanoContas = 0;
  previsaoReal = 'R';
  parcela = 1;
  dataEmissao = '';
  dataVencimento = '';
  dataRecebimento = '';
  idTipoRecebimento = 0;
  banco: number | null = null;
  valorImposto: number | null = null;
  valorDocumento: number | null = null;
  valorOutrasDespesas: number | null = null;
  valorDesconto: number | null = null;
  valorMulta: number | null = null;
  valorCustas: number | null = null;
  valorRecebido: number | null = null;
  valorJuros: number | null = null;
  taxaJuroSdia: number | null = null;
  valorCustasParcial: number | null = null;
  observacao = '';
  pago = false;
  dre = false;

  documentos: Opcao[] = [];
  usuarios: Opcao[] = [];
  centrosCustos: Opcao[] = [];
  planosContas: Opcao[] = [];
  tiposRecebimento: Opcao[] = [];
  bancos: Opcao[] = [];
  pagamentos: Opcao[] = [];
  itensComposicao: ItemComposicaoContaReceber[] = [];
  modalEditarComposicaoAberto = false;
  itemComposicaoEdicao: ItemComposicaoEdicao = {
    id: 0,
    descricao: '',
    quantidade: 1,
    valor: 0,
    planoContasId: 0
  };
  novoTipoPagamentoDescricao = '';
  novoBancoDescricao = '';
  salvandoBanco = false;

  constructor(
    private ajaxService: AjaxService,
    private util: UtilService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.carregarOpcoes();
    this.carregarCentrosCustos();
    this.route.queryParamMap.subscribe((params) => {
      this.id = Number(params.get('id') || 0);
      const pagamentoParam = (params.get('pagamento') || '').toLowerCase();
      this.ehPagamento = pagamentoParam === 'true' || pagamentoParam === '1';
      if (this.id > 0) this.carregar();
      else this.novo();
    });
  }

  novo(): void {
    this.id = 0;
    this.idFinDocumento = 0;
    this.idFinPagamento = null;
    this.idUsuarioPagador = null;
    this.idCentroCusto = 0;
    this.idPlanoContas = 0;
    this.previsaoReal = 'R';
    this.parcela = 1;
    this.dataEmissao = '';
    this.dataVencimento = '';
    this.dataRecebimento = '';
    this.idTipoRecebimento = 0;
    this.banco = null;
    this.valorImposto = null;
    this.valorDocumento = null;
    this.valorOutrasDespesas = null;
    this.valorDesconto = null;
    this.valorMulta = null;
    this.valorCustas = null;
    this.valorRecebido = null;
    this.valorJuros = null;
    this.taxaJuroSdia = null;
    this.valorCustasParcial = null;
    this.observacao = '';
    this.pago = false;
    this.dre = false;
    this.itensComposicao = [];
    this.fecharModalEditarComposicao();
  }

  private carregarCentrosCustos(): void {
    this.ajaxService.get(`${API}financeiro/centrocustos`).subscribe({
      next: (response) => {
        if (response?.hasErrors) {
          return;
        }
        this.centrosCustos = this.util.mapearOpcoesCentroCusto(this.util.extrairListaResponse(response));
      }
    });
  }

  private mapearTiposRecebimento(data: any): Opcao[] {
    return this.normalizarLista(data)
      .map((x: any) => ({ id: Number(x.id || 0), descricao: String(x.descricao || '') }))
      .filter((x: Opcao) => x.id > 0);
  }

  private carregarTiposRecebimento(idSelecionar?: number, descricaoSelecionar?: string): void {
    this.ajaxService.get(`${API}financeiro/TipoPagamento/Consultar`).subscribe({
      next: (response) => {
        if (response?.hasErrors) return;
        this.tiposRecebimento = this.mapearTiposRecebimento(this.util.extrairListaResponse(response));
        const descricao = (descricaoSelecionar || '').trim().toLowerCase();
        const selecionado = this.tiposRecebimento.find((x) => x.id === idSelecionar)
          || this.tiposRecebimento.find((x) => !!descricao && x.descricao.trim().toLowerCase() === descricao);
        if (selecionado) this.idTipoRecebimento = selecionado.id;
      }
    });
  }

  abrirModalTipoPagamento(content: TemplateRef<any>): void {
    this.novoTipoPagamentoDescricao = '';
    this.modalService.open(content);
  }

  salvarTipoPagamento(modal: NgbActiveModal): void {
    const descricao = String(this.novoTipoPagamentoDescricao || '').trim();
    if (descricao.length < 2) {
      this.util.toasterShowError('Atenção', 'Informe uma descrição válida.');
      return;
    }

    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/TipoPagamento/Salvar`, { id: 0, descricao }).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar o tipo de pagamento.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', 'Tipo de pagamento cadastrado!');
        modal.close();
        this.carregarTiposRecebimento(Number(response?.data?.id || 0), descricao);
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar tipo de pagamento.');
      }
    });
  }

  abrirModalBanco(content: TemplateRef<any>): void {
    this.novoBancoDescricao = '';
    this.modalService.open(content);
  }

  salvarBanco(modal: NgbActiveModal): void {
    if (this.salvandoBanco) return;
    const descricao = String(this.novoBancoDescricao || '').trim();
    if (descricao.length < 2) {
      this.util.toasterShowError('Atenção', 'Informe um nome de banco válido.');
      return;
    }

    this.salvandoBanco = true;
    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/FinBanco/Salvar`, { id: 0, descricao }).subscribe({
      next: (response) => {
        this.util.closeLoading();
        this.salvandoBanco = false;
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar o banco.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', 'Banco cadastrado!');
        modal.close();
        this.carregarBancos(Number(response?.data?.id || 0), descricao);
      },
      error: () => {
        this.util.closeLoading();
        this.salvandoBanco = false;
        this.util.toasterShowError('Erro', 'Erro ao salvar banco.');
      }
    });
  }

  private carregarBancos(idSelecionar?: number, descricaoSelecionar?: string): void {
    this.ajaxService.get(`${API}financeiro/FinBanco/Consultar`).subscribe({
      next: (response) => {
        if (response?.hasErrors) return;
        this.bancos = this.normalizarLista(this.util.extrairListaResponse(response))
          .map((x: any) => ({ id: Number(x.id || 0), descricao: String(x.descricao || '') }))
          .filter((x: Opcao) => x.id > 0);
        const descricao = (descricaoSelecionar || '').trim().toLowerCase();
        const selecionado = this.bancos.find((x) => x.id === idSelecionar)
          || this.bancos.find((x) => !!descricao && x.descricao.trim().toLowerCase() === descricao);
        if (selecionado) this.banco = selecionado.id;
      }
    });
  }

  carregarOpcoes(idUsuarioSelecionar?: number | null): void {
    this.ajaxService.get(`${API}financeiro/FinContaReceber/ConsultarOpcoes`).subscribe({
      next: (response) => {
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível carregar opções.');
          return;
        }

        const data = this.desempacotarResponse(response);
        const documentosData = data.documentos || data.docs || [];
        const usuariosData = data.usuarios || data.clientes || data.usuariospagador || [];
        const centrosCustosData = data.centroscustos || data.centros_custos || data.centros || [];
        const tiposRecebimentoData = data.tiposrecebimento || data.tipopagamento || data.tiposPagamento || [];
        const bancosData = data.bancos || [];
        const pagamentosData = data.pagamentos || data.finpagamentos || [];

        this.documentos = this.normalizarLista(documentosData)
          .map((x: any) => ({
            id: Number(x.id || 0),
            descricao: String(x.descricao || ''),
            dataEmissao: this.extrairDataEmissao(x)
          }))
          .filter((x: Opcao) => x.id > 0)
          .sort((a: Opcao, b: Opcao) => this.compararPorDataEmissaoDesc(a, b));
        this.usuarios = this.normalizarLista(usuariosData)
          .map((x: any) => ({
            id: Number(x.id || 0),
            descricao: String(x.descricao || '')
          }))
          .filter((x: Opcao) => x.id > 0);
        if (idUsuarioSelecionar && this.usuarios.some((u) => u.id === idUsuarioSelecionar)) {
          this.idUsuarioPagador = idUsuarioSelecionar;
        }
        this.centrosCustos = this.util.mapearOpcoesCentroCusto(this.normalizarLista(centrosCustosData));
        this.tiposRecebimento = this.mapearTiposRecebimento(tiposRecebimentoData);
        this.bancos = this.normalizarLista(bancosData)
          .map((x: any) => ({ id: Number(x.id || 0), descricao: String(x.descricao || '') }))
          .filter((x: Opcao) => x.id > 0);
        this.pagamentos = this.normalizarLista(pagamentosData)
          .map((x: any) => ({
            id: Number(x.id || 0),
            descricao: String(x.descricao || ''),
            dataEmissao: this.extrairDataEmissao(x)
          }))
          .filter((x: Opcao) => x.id > 0)
          .sort((a: Opcao, b: Opcao) => this.compararPorDataEmissaoDesc(a, b));

        if (this.documentos.length === 0 || this.usuarios.length === 0 || this.tiposRecebimento.length === 0) {
          this.util.toasterShowError('Atenção', 'Alguns selects vieram vazios. Verifique o cadastro base no banco.');
        }

        this.carregarPlanosContasSaidaAnalitica();
      },
      error: () => {
        this.util.toasterShowError('Erro', 'Falha ao carregar opções da tela.');
      }
    });
  }

  private carregarPlanosContasSaidaAnalitica(): void {
    this.ajaxService.get(`${API}financeiro/FinContaReceber/ConsultarPlanosContasSaidaAnalitica`).subscribe({
      next: (response) => {
        if (response?.hasErrors) return;
        const data = this.desempacotarResponse(response);
        this.planosContas = this.normalizarLista(data)
          .map((x: any) => ({ id: Number(x.id || 0), descricao: String(x.descricao || '') }))
          .filter((x: Opcao) => x.id > 0);
      },
      error: () => {
        this.planosContas = [];
      }
    });
  }

  carregar(): void {
    this.carregandoRegistro = true;
    this.util.showLoading();
    this.ajaxService.get(`${API}financeiro/FinContaReceber/Obter?id=${this.id}`).subscribe({
      next: (response) => {
        this.util.closeLoading();
        const data = this.desempacotarResponse(response);
        this.idFinPagamento = data.idfinpagamento != null ? Number(data.idfinpagamento) : null;
        this.parcela = Number(data.parcela || 1);
        this.idUsuarioPagador = data.idusuariopagador != null ? Number(data.idusuariopagador) : null;
        this.idCentroCusto = Number(data.idcentrocusto || 0);
        this.previsaoReal = String(data.previsaoreal || 'R').toUpperCase() === 'P' ? 'P' : 'R';
        this.dataEmissao = this.toDateInput(data.dataemissao);
        this.dataVencimento = this.toDateInput(data.datavencimento);
        this.dataRecebimento = this.toDateInput(data.datarecebimento);
        this.idTipoRecebimento = Number(data.idtiporecebimento || 0);
        this.banco = data.idfinbanco != null && Number(data.idfinbanco) > 0 ? Number(data.idfinbanco) : null;
        this.valorImposto = data.valorimposto != null ? Number(data.valorimposto) : null;
        this.valorDocumento = data.valordocumento != null ? Number(data.valordocumento) : null;
        this.valorOutrasDespesas = data.valoroutrasdespesas != null ? Number(data.valoroutrasdespesas) : null;
        this.valorDesconto = data.valordesconto != null ? Number(data.valordesconto) : null;
        this.valorMulta = data.valormulta != null ? Number(data.valormulta) : null;
        this.valorCustas = data.valorcustas != null ? Number(data.valorcustas) : null;
        this.valorRecebido = data.valorrecebido != null ? Number(data.valorrecebido) : null;
        this.valorJuros = data.valorjuros != null ? Number(data.valorjuros) : null;
        this.taxaJuroSdia = data.taxajurosdia != null ? Number(data.taxajurosdia) : null;
        this.valorCustasParcial = data.valorcustasparcial != null ? Number(data.valorcustasparcial) : null;
        this.observacao = String(data.observacao || '');
        this.pago = this.util.parseBoolean(data.pago);
        this.dre = this.util.parseBoolean(data.dre);
        this.itensComposicao = this.normalizarLista(data.itenscomposicao || data.itensComposicao)
          .map((x: any) => ({
            id: Number(x.id || 0),
            quantidade: Number(x.quantidade || 0),
            descricao: String(x.descricao || ''),
            valor: Number(x.valor || 0),
            dataCadastro: x.datacadastro || x.dataCadastro || null,
            idOrcamento: x.idorcamento != null ? Number(x.idorcamento) : null,
            idOrcamentoItens: x.idorcamentoitens != null ? Number(x.idorcamentoitens) : null,
            idFinTabelaPreco: x.idfintabelapreco != null ? Number(x.idfintabelapreco) : null,
            planoContasId: x.planocontasid != null ? Number(x.planocontasid) : null,
            planoContasDescricao: String(x.planocontasdescricao || x.planoContasDescricao || '')
          }))
          .filter((x: ItemComposicaoContaReceber) => x.id > 0);
        this.preencherPlanoContasDaComposicao();
        this.carregandoRegistro = false;
      },
      error: () => {
        this.util.closeLoading();
        this.carregandoRegistro = false;
        this.util.toasterShowError('Erro', 'Não foi possível carregar a conta a receber.');
      }
    });
  }

  calcularValorRecebido(): void {
    const payload = {
      valorImposto: this.valorImposto,
      valorDocumento: this.valorDocumento,
      valorOutrasDespesas: this.valorOutrasDespesas,
      valorDesconto: this.valorDesconto,
      valorMulta: this.valorMulta,
      valorCustas: this.valorCustas,
      valorJuros: this.valorJuros,
      valorCustasParcial: this.valorCustasParcial
    };

    this.ajaxService.post(`${API}financeiro/FinContaReceber/CalcularValorRecebido`, payload).subscribe({
      next: (response) => {
        const data = this.desempacotarResponse(response);
        const valor = Number(data);
        if (!Number.isNaN(valor)) this.valorRecebido = valor;
      }
    });
  }

  salvar(): void {
    if (!this.dataEmissao) {
      this.util.toasterShowError('Atenção', 'Data de emissão é obrigatória.');
      return;
    }
    if (this.valorDocumento == null) {
      this.util.toasterShowError('Atenção', 'Valor do documento é obrigatório.');
      return;
    }
    if (!this.idPlanoContas || this.idPlanoContas <= 0) {
      this.util.toasterShowError('Atenção', 'Plano de Contas é obrigatório. Selecione uma opção da lista.');
      return;
    }
    if (this.temValorRecebidoInformado() && !this.dataRecebimento?.trim()) {
      this.util.toasterShowError('Atenção', 'Informe a data de recebimento quando houver valor em «Valor recebido».');
      return;
    }
    if (this.ehPagamento && (!this.dataRecebimento || this.valorRecebido == null)) {
      this.util.toasterShowError('Atenção', 'Para recebimento, informe Data de Recebimento e Valor Recebido.');
      return;
    }
    const idUsuarioLogado = this.getIdUsuarioLogado();
    if (!idUsuarioLogado) {
      this.util.toasterShowError('Atenção', 'Não foi possível identificar o usuário logado.');
      return;
    }

    const payload = {
      id: this.id || 0,
      idUsuarioLogado,
      idFinDocumento: this.idFinDocumento > 0 ? this.idFinDocumento : null,
      idFinPagamento: this.idFinPagamento,
      idUsuarioPagador: this.idUsuarioPagador,
      idCentroCusto: this.idCentroCusto > 0 ? this.idCentroCusto : null,
      planoContasId: this.idPlanoContas,
      idPlanoContas: this.idPlanoContas,
      previsaoReal: this.previsaoReal === 'P' ? 'P' : 'R',
      parcela: this.parcela || 1,
      dataEmissaoTexto: this.dataEmissao || null,
      dataVencimentoTexto: this.dataVencimento || null,
      dataRecebimentoTexto: this.dataRecebimento || null,
      idTipoRecebimento: this.idTipoRecebimento > 0 ? this.idTipoRecebimento : null,
      banco: this.banco,
      valorImposto: this.valorImposto,
      valorDocumento: this.valorDocumento,
      valorOutrasDespesas: this.valorOutrasDespesas,
      valorDesconto: this.valorDesconto,
      valorMulta: this.valorMulta,
      valorCustas: this.valorCustas,
      valorRecebido: this.valorRecebido,
      valorJuros: this.valorJuros,
      pago: this.pago,
      dre: this.dre,
      taxaJuroSdia: this.taxaJuroSdia,
      valorCustasParcial: this.valorCustasParcial,
      observacao: this.observacao,
      ehPagamento: this.ehPagamento
    };

    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/FinContaReceber/Salvar`, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', this.id > 0 ? 'Conta a receber atualizada com sucesso!' : 'Conta a receber cadastrada com sucesso!');
        this.router.navigate(['/consultar-contas-receber']);
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar conta a receber.');
      }
    });
  }

  voltar(): void {
    this.router.navigate(['/consultar-contas-receber']);
  }

  formatMoneyBRL(valor: number | null | undefined): string {
    return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  /** Valor recebido preenchido e diferente de zero (exige data de recebimento). */
  private temValorRecebidoInformado(): boolean {
    if (this.valorRecebido == null) return false;
    const n = Number(this.valorRecebido);
    if (Number.isNaN(n)) return false;
    return n !== 0;
  }

  abrirModalEditarComposicao(item: ItemComposicaoContaReceber): void {
    this.garantirPlanoContasEdicaoDisponivel(item);

    this.itemComposicaoEdicao = {
      id: item.id,
      descricao: item.descricao,
      quantidade: Number(item.quantidade || 1),
      valor: Number(item.valor || 0),
      planoContasId: Number(item.planoContasId || 0)
    };
    this.modalEditarComposicaoAberto = true;
  }

  abrirModalNovoCliente(): void {
    this.modalNovoClienteAberto = true;
  }

  fecharModalNovoCliente(): void {
    this.modalNovoClienteAberto = false;
  }

  onClienteCadastrado(evento: { idPaciente: number; idUsuario: number | null }): void {
    this.modalNovoClienteAberto = false;
    this.carregarOpcoes(evento?.idUsuario);
  }

  fecharModalEditarComposicao(): void {
    this.modalEditarComposicaoAberto = false;
    this.itemComposicaoEdicao = {
      id: 0,
      descricao: '',
      quantidade: 1,
      valor: 0,
      planoContasId: 0
    };
  }

  salvarItemComposicao(): void {
    if (this.itemComposicaoEdicao.id <= 0) {
      this.util.toasterShowError('Erro', 'Item de composição inválido.');
      return;
    }

    if (this.itemComposicaoEdicao.quantidade <= 0) {
      this.util.toasterShowError('Atenção', 'Informe uma quantidade válida.');
      return;
    }

    if (this.itemComposicaoEdicao.valor < 0) {
      this.util.toasterShowError('Atenção', 'Informe um valor válido.');
      return;
    }

    const payload = {
      id: this.itemComposicaoEdicao.id,
      quantidade: Number(this.itemComposicaoEdicao.quantidade || 0),
      valor: Number(this.itemComposicaoEdicao.valor || 0),
      planoContasId: this.itemComposicaoEdicao.planoContasId > 0 ? this.itemComposicaoEdicao.planoContasId : null
    };

    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/FinContaReceber/SalvarItemComposicao`, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar o item de composição.');
          return;
        }

        this.util.toasterShowSuccess('Sucesso', 'Item de composição atualizado com sucesso!');
        this.fecharModalEditarComposicao();
        this.carregar();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar item de composição.');
      }
    });
  }

  private garantirPlanoContasEdicaoDisponivel(item: ItemComposicaoContaReceber): void {
    const planoContasId = Number(item.planoContasId || 0);
    if (planoContasId <= 0) {
      return;
    }

    const jaExiste = this.planosContas.some((plano) => Number(plano.id) === planoContasId);
    if (jaExiste) {
      return;
    }

    this.planosContas = [
      {
        id: planoContasId,
        descricao: item.planoContasDescricao || `Plano ${planoContasId}`
      },
      ...this.planosContas
    ];
  }

  private toDateInput(value: any): string {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  private normalizarLista(data: any): any[] {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === 'object') {
      if (Object.prototype.hasOwnProperty.call(data, 'id') || Object.prototype.hasOwnProperty.call(data, 'descricao')) return [data];
      return Object.values(data).filter((x: any) => x && typeof x === 'object');
    }
    return [];
  }

  private preencherPlanoContasDaComposicao(): void {
    const comPlano = this.itensComposicao.find((item) => Number(item.planoContasId || 0) > 0)
      || (this.itensComposicao.length === 1 ? this.itensComposicao[0] : null);

    if (!comPlano || Number(comPlano.planoContasId || 0) <= 0) {
      this.idPlanoContas = 0;
      return;
    }

    this.idPlanoContas = Number(comPlano.planoContasId);
    this.garantirPlanoContasEdicaoDisponivel(comPlano);
  }

  private desempacotarResponse(response: any): any {
    let atual = response;
    for (let i = 0; i < 3; i++) {
      if (atual && typeof atual === 'object' && Object.prototype.hasOwnProperty.call(atual, 'data') && atual.data != null) {
        atual = atual.data;
      } else {
        break;
      }
    }
    return this.util.converterParaLowercase(atual ?? {});
  }

  private getIdUsuarioLogado(): number | null {
    const userData = this.userService.getUserData();
    if (!userData) return null;

    const userId =
      Number(userData.User?.Id) ||
      Number((userData as any)?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid']) ||
      0;

    return userId > 0 ? userId : null;
  }

  private extrairDataEmissao(item: any): string | null {
    const dataDireta = String(
      item?.dataemissao ||
      item?.dataEmissao ||
      item?.dtEmissao ||
      item?.data_emissao ||
      ''
    ).trim();

    if (dataDireta) return dataDireta;

    const descricao = String(item?.descricao || '');
    const dataDaDescricao = this.extrairDataDaDescricao(descricao);
    return dataDaDescricao || null;
  }

  private compararPorDataEmissaoDesc(a: Opcao, b: Opcao): number {
    const timestampA = this.converterDataParaTimestamp(a?.dataEmissao);
    const timestampB = this.converterDataParaTimestamp(b?.dataEmissao);
    if (timestampA !== timestampB) return timestampB - timestampA;
    return String(a?.descricao || '').localeCompare(String(b?.descricao || ''));
  }

  private extrairDataDaDescricao(texto: string): string {
    const valor = String(texto || '');
    const matchBr = valor.match(/\b(\d{2}\/\d{2}\/\d{4})\b/);
    if (matchBr?.[1]) return matchBr[1];
    const matchIso = valor.match(/\b(\d{4}-\d{2}-\d{2})\b/);
    if (matchIso?.[1]) return matchIso[1];
    return '';
  }

  private converterDataParaTimestamp(dataTexto: string | null | undefined): number {
    const valor = String(dataTexto || '').trim();
    if (!valor) return 0;

    const br = valor.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (br) {
      const dia = Number(br[1]);
      const mes = Number(br[2]);
      const ano = Number(br[3]);
      return new Date(ano, mes - 1, dia).getTime();
    }

    const iso = valor.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
      const ano = Number(iso[1]);
      const mes = Number(iso[2]);
      const dia = Number(iso[3]);
      return new Date(ano, mes - 1, dia).getTime();
    }

    const parsePadrao = new Date(valor).getTime();
    return Number.isFinite(parsePadrao) ? parsePadrao : 0;
  }
}
